__turbopack_context__.v({
  "heroFeatureItem": "heroFeatures-module-scss-module__K-XJYa__heroFeatureItem",
  "heroFeatures": "heroFeatures-module-scss-module__K-XJYa__heroFeatures",
  "heroFeaturesContainer": "heroFeatures-module-scss-module__K-XJYa__heroFeaturesContainer",
  "heroFeaturesInner": "heroFeatures-module-scss-module__K-XJYa__heroFeaturesInner",
});
